<template>
  <div style="margin: 0 10px; color: black; font-size: 12px; font-weight: 500">
    <el-form label-position="right" label-width="80px" :model="work" :rules="rules" size="mini" ref="work">
      <div>车辆&客户信息</div>
      <el-row style="margin-top: 10px">
        <el-col :span="8" class="basic-column">
          <el-form-item label="车牌" :prop="isEdit ? 'carNo' : ''">
            <div v-if="!isEdit" class="value">{{work.carNo | carNo}}</div>
            <el-input v-else v-model="work.carNo" onchange="value=value.toUpperCase()" @change="changeCarNo"></el-input>
          </el-form-item>
          <el-form-item label="车主姓名">
            <div v-if="!isEdit" class="value">{{work.ownerName || '空'}}</div>
            <el-input v-else v-model="work.ownerName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="basic-column">
          <el-form-item label="品牌/车系" prop="brandModel">
            <div v-if="!isEdit" v-loading="$isEmpty(brandNameMap)" class="value">
              {{brandNameMap[work.brandModel[0]]}} / {{work.brandModel[1]}}
            </div>
            <brand-select v-else class="fullwidth" v-model="work.brandModel"></brand-select>
          </el-form-item>
          <el-form-item label="联系电话">
            <div v-if="!isEdit" class="value">{{work.phone || '空'}}</div>
            <el-input v-else v-model="work.phone" @change="changeOwnerCellphone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="basic-column">
          <el-form-item label-width="94px" label="颜色" prop="color">
            <div v-if="!isEdit" class="value" :style="{'width':'150px', 'background-color': work.color}">
              {{work.color === 'white' ? '白' : '&nbsp;'}}
            </div>
            <color-select v-else v-model="work.color"></color-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-top: 10px">工单信息</div>
      <el-row style="margin-top: 10px">
        <el-col :span="8" class="basic-column">
          <el-form-item label="工单号">
            <div v-if="!isEdit" class="value">{{work.extraId || work.id}}</div>
            <el-input v-else v-model="work.extraId" placeholder="为空采用默认工单号"></el-input>
          </el-form-item>
          <el-form-item label="服务顾问" :prop="(!isEdit || isConsultant)? '' : 'consultantId'">
            <div v-if="!isEdit" class="value">{{work.consultantName}}</div>
            <template v-else>
              <div v-if="isConsultant" class="value">
                {{$store.state.user.name}}
              </div>
              <div v-else>
                <consultant-select v-model="work.consultantId" class="fullwidth"></consultant-select>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="进厂时间" prop="enterTime">
            <div class="value">
              {{work.enterTime ? work.enterTime.format('yyyy-MM-dd hh:mm') : ''}}
            </div>
          </el-form-item>
          <el-form-item label="是否外返">
            <div v-if="!isEdit" class="value">
              {{work.isOutsideRework===1 ? '是' : '否'}}
            </div>
            <el-radio-group v-else v-model="work.isOutsideRework">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="basic-column">
          <el-form-item label="付款方式" prop="payMethodCode">
            <div v-if="!isEdit" class="value" v-loading="$isEmpty(payMethodLabelMap)">
              {{payMethodLabelMap[work.payMethodCode]}}
            </div>
            <remote-select v-else class-name="PAY_METHOD" v-model="work.payMethodCode" using-code
                           class="fullwidth"></remote-select>
          </el-form-item>
          <el-form-item v-if="isInsurancePay" label="保险公司" :prop="isInsurancePay ? 'insuranceCompanyId' :''" key="0">
            <div v-if="!isEdit" class="value" v-loading="$isEmpty(insuranceCompanyMap)">
              {{insuranceCompanyMap[work.insuranceCompanyId]}}
            </div>
            <remote-select v-else
                           class-name="INSURANCE_COMPANY" v-model="work.insuranceCompanyId"
                           class="fullwidth">
            </remote-select>
          </el-form-item>
          <el-form-item v-else label="保险公司">
            <remote-select :disabled="true"
                           class-name="INSURANCE_COMPANY" v-model="work.insuranceCompanyId"
                           class="fullwidth">
            </remote-select>
          </el-form-item>
          <el-form-item label="维修时间">
            <span class="value">{{repairDays}}</span>
            <span style="color: #606266; font-size: 12px; margin-left: 10px">天</span>
          </el-form-item>
          <el-form-item v-if="work.isOutsideRework===1" label="外返原因" prop="outsideReworkReasonId">
            <div v-if="!isEdit" class="value" v-loading="$isEmpty(OutsideReworkMap)">
              {{OutsideReworkMap[work.outsideReworkReasonId]}}
            </div>
            <remote-select v-else class-name="OUTSIDE_REWORK_REASON" v-model="work.outsideReworkReasonId"
                           class="fullwidth"></remote-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="basic-column">
          <el-form-item label-width="94px" label="预计完成时间">
            <div class="value">
              {{work.enterTime ? work.enterTime.format('yyyy-MM-dd hh:mm') : ''}}
            </div>
          </el-form-item>
          <el-form-item label-width="94px" label="预计交车时间" prop="estimateDeliveryTime">
            <div v-if="isRead" class="value">
              {{work.estimateDeliveryTime ? work.estimateDeliveryTime.format('yyyy-MM-dd hh:mm') : ''}}
            </div>
            <el-date-picker v-else
                            class="fullwidth"
                            v-model="work.estimateDeliveryTime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="选择交车时间"
                            :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否加急">
            <div v-if="!isEdit" class="value">
              {{work.urgent ? '是' : '否'}}
            </div>
            <el-radio-group v-else v-model="work.urgent">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" class="basic-column">
        <div v-if="!isEdit" class="value">{{work.remarks || '空'}}</div>
        <el-input v-else type="textarea" :rows="5" v-model="work.remarks" maxlength="1000"
                  resize="none"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

  import { shareDataMixin } from '@/views/mixins/ShareData'
  import BrandSelect from '@/components/selector/BrandSelect'
  import ColorSelect from '@/components/selector/ColorSelect'
  import ConsultantSelect from '@/components/selector/ConsultantSelect'
  import RemoteSelect from '@/components/selector/RemoteSelect'
  import { isCarNo } from '@/utils/validate'
  import { checkHasPosition } from '@/utils/auth-directive'
  import { customerByCarNo, customerByCellphone } from '@/utils/request'

  export default {
    name: 'BasicWorkPane2',
    mixins: [shareDataMixin],
    components: {
      RemoteSelect,
      ConsultantSelect,
      ColorSelect,
      BrandSelect
    },
    props: {
      work: {
        type: Object,
        required: true
      },
      pattern: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        rules: {
          carNo: [
            {
              required: true,
              trigger: 'change',
              validator (rule, value, callback) {
                if (rule.required) {
                    if (!isCarNo(value.replace(/\s*/g, ''))) {
                        callback(new Error('请输入正确车牌号'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
              }
            }
          ],
          brandModel: [
            {
              required: true,
              message: '请输入品牌/型号',
              trigger: 'change'
            }
          ],
          color: [
            {
              required: true,
              message: '请输入颜色',
              trigger: 'change'
            }
          ],
          ownerName: [
            {
              required: true,
              message: '请输入车主姓名',
              trigger: 'blur'
            }
          ],
          estimateDeliveryTime: [
            {
              required: true,
              message: '请输入交车时间',
              trigger: 'change'
            }
          ],
          consultantId: [
            {
              required: true,
              message: '请选择顾问',
              trigger: 'change'
            }
          ],
          insuranceCompanyId: [
            {
              required: true,
              message: '请选择保险公司',
              trigger: 'change'
            }
          ],
          outsideReworkReasonId: [
            {
              required: true,
              message: '请选择外返原因',
              trigger: 'change'
            }
          ]
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getLocalDays() < new Date().getLocalDays()
          }
        }
      }
    },
    created () {
        if (this.$store.state.data.ConsultantsOfShop[0].workshopCode === 'shbnworkshop') { // 固定一家门店不需要做车牌验证
            this.rules.carNo[0].required = false
        }
    },
    methods: {
      changeCarNo () {
        const carNo = this.work.carNo.toUpperCase()
        if (!isCarNo(carNo)) return
        customerByCarNo(carNo).then(response => {
          const customer = response.data
          if (!customer) return
          this.work.ownerName = customer.name
          this.work.phone = customer.cellphone
          this.work.brandModel = customer.brandModel
          this.work.color = customer.color
        })
      },
      changeOwnerCellphone () {
        const phone = this.work.phone
        if (!phone) return
        customerByCellphone(phone).then(response => {
          const customer = response.data
          if (!customer) return
          this.work.ownerName = customer.name
          this.work.carNo = customer.carNo
          this.work.brandModel = customer.brandModel
          this.work.color = customer.color
        })
      }
    },
    computed: {
      repairDays () {
        if (!this.work.estimateDeliveryTime) return '?'
        return this.work.estimateDeliveryTime.getLocalDays() - this.work.enterTime.getLocalDays() + 1
      },
      isRead () {
        return this.pattern === 'READ'
      },
      isEdit () {
        return this.pattern === 'NEW' || this.pattern === 'EDIT'
      },
      isConsultant () {
        return checkHasPosition('CONSULTANT_PO')
      },
      isInsurancePay () {
        return this.work.payMethodCode === 'insurance_company'
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-form-item__label {
    font-size: 12px;
  }

  /deep/ .el-form-item--mini.el-form-item {
    margin-bottom: 16px;
  }

  .basic-column {
    padding-right: 50px;
  }

  .topForm {
    margin-top: 10px;
  }

  .topLabel {
    margin-left: 10px;
  }

  /deep/ .el-form-item {
    margin-bottom: 15px !important;
  }
</style>
